// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadGuestsTab__wrapper___xbk18","buttons":"UploadGuestsTab__buttons___2jvRI","content":"UploadGuestsTab__content___33ijZ"};